export default {
  missingInfosListingsCount: {
    id: 'listings_missing_infos_offers_count',
    defaultMessage: `{offersTotalCount, plural,
        one {# listing with missing information}
        other {# listings with missing information}
      }`,
  },
  inValidationListingsCount: {
    id: 'listings_in_validation_offers_count',
    defaultMessage: `{offersTotalCount, plural,
        one {# listing in validation}
        other {# listings in validation}
      }`,
  },
  archivedListingsCount: {
    id: 'listings_archived_offers_count',
    defaultMessage: `{offersTotalCount, plural,
        one {# archived listing}
        other {# archived listings}
      }`,
  },
  activeListingsCount: {
    id: 'listings_active_offers_count_new',
    defaultMessage: `{offersTotalCount, plural,
        one {# active listing}
        other {# active listings}
      }`,
  },
  listingCountLabel: {
    id: 'listings_view_select_number_of_listing_label',
    defaultMessage: 'Number of listings',
  },
  displayTypes: {
    id: 'listings_display',
    defaultMessage: 'Display',
  },
  simpleView: {
    id: 'listings_display_simple',
    defaultMessage: 'Simple view',
  },
  detailedView: {
    id: 'listings_display_detailed',
    defaultMessage: 'Detailed view',
  },
  referenceMarket: {
    id: 'listings_main_market',
    defaultMessage: 'Main market',
  },
  sortBy: {
    id: 'listings_sort_order_by',
    defaultMessage: 'Sort by',
  },
  sortStockAscending: {
    id: 'listings_sort_stock_ascending',
    defaultMessage: 'Stock (ascending)',
  },
  sortStockDescending: {
    id: 'listings_sort_stock_descending',
    defaultMessage: 'Stock (descending)',
  },
  sortAlphabeticalAscending: {
    id: 'listings_sort_alphabetical_order_ascending',
    defaultMessage: 'Alphabetical order (A-Z)',
  },
  sortAlphabeticalDescending: {
    id: 'listings_sort_alphabetical_order_descending',
    defaultMessage: 'Alphabetical order (Z-A)',
  },
  expandedView: {
    id: 'bo_seller.listings.listings_sorting_filters.expand_listings_toggle.label',
    defaultMessage: 'Expand all',
  },
}
